import { Stage } from "..";
/* eslint-disable */

const API_BASE_URL = (process.env.REACT_APP_API_BASE_URL || "/tenant/api/v1").trim();
// const API_BASE_URL = "https://stage.ikhub.biz/tenant/api/v1".trim();

const CURRENT_STAGE = process.env.REACT_APP_ENV === "dev" ? Stage.DEV : Stage.PROD;

export { API_BASE_URL, CURRENT_STAGE };

export const API_MOCK_URL = `${API_BASE_URL}/catalog/products`;

// Catalogs
export const UPC_URL = `${API_BASE_URL}/catalog/products/upc-image`;
export const BRAND_URL = `${API_BASE_URL}/catalog/brands`;
export const CATEGORY_URL = `${API_BASE_URL}/catalog/categories`;
export const CATEGORY_EXPORT = `${API_BASE_URL}/catalog/categories/export`;
export const CATEGORY_IMPORT = `${API_BASE_URL}/catalog/categories`;
export const PRODUCT_URL = `${API_BASE_URL}/catalog/products`;
export const MANUFACTURER_URL = `${API_BASE_URL}/catalog/manufacturers`;
export const SUPPLIER_URL = `${API_BASE_URL}/inventory/suppliers`;
export const VENDOR_PORTAL_ADMIN_URL = `${API_BASE_URL}/inventory/vendor-portal`;
export const KONNECT_URL = `${API_BASE_URL}/inventory/konnect`;
export const TAG_URL = `${API_BASE_URL}/catalog/tags`;
export const ATTRIBUTE_URL = `${API_BASE_URL}/catalog/attributes`;
export const CHATGPT_DISCRIP_URL = `${API_BASE_URL}/catalog/products/product-description`;
export const STOCKS_BULK_EDIT_URL = `${API_BASE_URL}/catalog/products/bulk_update_stock`;
export const PRODUCT_VARIANT = `${API_BASE_URL}/catalog/products/variant`;
export const UPC_CHECK_URL = `${API_BASE_URL}/catalog/products/upc-exists`;
export const BULK_UPDATE_URL = `${API_BASE_URL}/catalog/products/action/bulk`;
export const PRODUCT_LIST3_URL = `${API_BASE_URL}/catalog/products/list3`;
export const PRODUCT_UPDATE_PRICES_URL = `${API_BASE_URL}/catalog/products/update-prices`;
export const EXPORT_LABEL_URL = `${API_BASE_URL}/catalog/products/export/labels`;
export const GENERATE_UPC_URL = `${API_BASE_URL}/catalog/products/generate-upc`;
export const ACTIVITY_LOGS_URL = `${API_BASE_URL}/core/utils/audit-logs/list`;
export const ACTIVITY_LOGS_NEW = `${API_BASE_URL}/core/utils/audit-logs-new/list`;
export const CUSTOMER_LOGS_EXPORT_URL = `${API_BASE_URL}/sale/customers/customer_log/export`;
export const PRODUCTS_GROUPS_URL = `${API_BASE_URL}/catalog/products/groups`;

// Inventory
export const CHANNEL_URL = `${API_BASE_URL}/inventory/channel`;
export const WAREHOUSE_URL = `${API_BASE_URL}/inventory/warehouse`;
export const STORAGES_URL = `${API_BASE_URL}/inventory/storage`;
export const STOREFRONT_URL = `${API_BASE_URL}/inventory/storefront`;
export const PURCHASE_ORDER_URL = `${API_BASE_URL}/inventory/purchase/orders`;
export const PURCHASE_ORDER_PAYMENT = `${API_BASE_URL}/inventory/purchase/payment`;
export const PURCHASE_ORDER_V2_URL = `${API_BASE_URL}/inventory/purchase/v2/orders`;
export const SUPPLIER_PURCHASE_HISTORY_URL = `${API_BASE_URL}/inventory/purchase/v2/receives/list?`;
export const SUPPLIER_PURCHASE_RETURN_HISTORY_URL = `${API_BASE_URL}/inventory/purchase/v2/returns/list?`;
export const PURCHASE_ORDER_V2_BULK_INVOICE_PAY = `${API_BASE_URL}/inventory/purchase/v2/orders/bulk_inv_pay`;
export const PURCHASE_RECEIVE_V2_URL = `${API_BASE_URL}/inventory/purchase/v2/receives`;
export const PURCHASE_RECEIVE_URL = `${API_BASE_URL}/inventory/purchase/receives`;
export const STOCK_URL = `${API_BASE_URL}/inventory/stocks`;
export const LOCATION_URL = `${API_BASE_URL}/inventory/locations`;
export const STOCK_BUCKET_URL = `${API_BASE_URL}/inventory/stock-buckets`;
export const STOCK_TRANSFER_URL = `${API_BASE_URL}/inventory/stocks/transfer`;
export const PURCHASE_RETURN_URL = `${API_BASE_URL}/inventory/purchase-returns`;
export const PURCHASE_RETURN_URL_v2 = `${API_BASE_URL}/inventory/purchase/v2/returns`;
export const SUPPLIER_EXPORT = `${API_BASE_URL}/inventory/suppliers/export`;
export const SUPPLIERS_IMPORT_URL = `${API_BASE_URL}/inventory/suppliers`;
export const SUPPLIER_LEDGER_EMAIL_URL = `${API_BASE_URL}/inventory/suppliers`;
export const prevSupplyPrices = `${API_BASE_URL}/inventory/purchase/v2/orders/prev-supply-prices`;
export const LAST3POS = `${API_BASE_URL}/inventory/purchase/v2/orders`;
export const SUPPLIER_PURCHASE_ORDER_BY_ID = `${API_BASE_URL}/inventory/purchase/v2/receives`;
export const SUPPLIER_PURCHASE_RETURN_ORDER_BY_ID = `${API_BASE_URL}/inventory/purchase/v2/returns`;
export const SUPPLIER_LEGDER_URL = `${API_BASE_URL}/inventory/ledgers/list`;
export const SUPPLIER_LEDGER_SIMPLIFIED_REGENERATE = `${API_BASE_URL}/inventory/ledgers/simplified/regenerate`;
export const SUPPLIER_BALANCE_ADJUSTMENT_URL = `${API_BASE_URL}/inventory/ledgers/adjustment`;
export const SUPPLIER_LEDGER_CSV_PDF_URL = `${API_BASE_URL}/report/inv/ledger`;
export const SEND_SUPPLIER_INVOICE_EMAIL_URL = `${API_BASE_URL}/core/utils/email/send_supplier_invoices`;
export const SUPPLIER_PAYMENT_URL = `${API_BASE_URL}/inventory/purchase/payment`;

//Sale
export const CUSTOMERS_URL = `${API_BASE_URL}/sale/customers`;
export const CUSTOMER_PERFORMANCE_REPORT_URL = `${API_BASE_URL}/report/sale/customer/customer_performance_report`;
export const CUSTOMER_GROUPS_URL = `${API_BASE_URL}/sale/customers/groups`;
export const CUSTOMER_CHECK_URL = `${API_BASE_URL}/sale/customers/groups/customer_check`;
export const PRODUCT_CHECK_URL = `${API_BASE_URL}/sale/customers/groups/product_check`;
export const CUSTOMER_LEADS_URL = `${API_BASE_URL}/sale/customers/list2?search_key=&customer_type=&allow_ecom=&sale_agent_ids=&on_account_min=&is_active=-1&page=1&page_size=20&sort_by=id:desc&waiting_for_approval=Y`;
export const APPROVE_REJECT_CUSTOMER_LEAD = `${API_BASE_URL}/sale/customers/approve-customer`;
export const APPLY_BULK_ACTIONS_URL = `${API_BASE_URL}/sale/customers/bulk_update_customer`;
export const COUPONS_URL = `${API_BASE_URL}/sale/coupon/validate`;
export const PRODUCTS_URL = `${API_BASE_URL}/catalog/products`;
export const ORDER_URL = `${API_BASE_URL}/sale/order`;
export const PAYMENT_URL = `${API_BASE_URL}/sale/payment`;
export const PAYMENT_RECEIPT_URL = `${API_BASE_URL}/core/utils/email/send_payment_receipt`;
export const CUST_ACH_ONBOARD_PUBLIC_URL = `${API_BASE_URL}/payment/customer/public`;
export const PAYMENT_MAIL_INVOICE = `${API_BASE_URL}/sale/payment/email-invoice`;
export const ORDER_RETURN_URL = `${API_BASE_URL}/sale/return`;
export const REGISTER_URL = `${API_BASE_URL}/auth/register`;
export const REQUEST_PASSWORD_URL = `${API_BASE_URL}/auth/forgot-password`;
export const CUSTOMER_REPORT = `${API_BASE_URL}/sale/customers/export`;
export const CALC_ORDER_URL = `${API_BASE_URL}/sale/order/calc-charges`;
export const PREV_PROD_SOLD_PRICE = `${API_BASE_URL}/sale/order/prev-sold-prices`;
export const LAST3SO = `${API_BASE_URL}/sale/order/recent`;
export const CUSTOMER_LEDGER_STATS = `${API_BASE_URL}/sale/ledgers/list`;
export const CUSTOMER_LEDGER_SUMMARY_REGENERATE = `${API_BASE_URL}/sale/ledgers/summary/regenerate`;
export const CUSTOMER_LEDGER_SIMPLIFIED_REGENERATE = `${API_BASE_URL}/sale/ledgers/simplified/regenerate`;
export const PRODUCT_CUETIP_URL = `${API_BASE_URL}/sale/order/recent-sales-list`;
export const SEND_PO_INVOICE_EMAIL_URL = `${API_BASE_URL}/core/utils/email/po_invoice`;
export const SEND_PURCHASE_RECIEVE_INVOICE_EMAIL_URL = `${API_BASE_URL}/core/utils/email/pr_invoice`;
export const SEND_PURCHASE_RETURN_INVOICE_EMAIL_URL = `${API_BASE_URL}/core/utils/email/purchase_return`;
export const CUSTOMER_BALANCE_ADJUSTMENT_URL = `${API_BASE_URL}/sale/balance/adjustment/customer`;
export const SEND_CUSTOMER_INVOICE_EMAIL = `${API_BASE_URL}/core/utils/email/send_customer_invoices`;
export const PAYMENT_COLLECTION_URL = `${API_BASE_URL}/driver/payment-collections`;

// Spiff (commission portal)
export const SPIFF_URL = `${API_BASE_URL}/sale/spiff`;
export const SPIFF_REPORT_URL = `${API_BASE_URL}/report/sale/spiff`;
// Marketing
export const PROMOTIONS_URL = `${API_BASE_URL}/marketing/promotions`;
export const WHATSAPP_MESSAGE_TRIGGER_URL = `${API_BASE_URL}/core/utils/whatsapp/message`;
export const REGISTER_CUSTOMER_ON_WHATSAPP_URL = `${API_BASE_URL}/integrations/whatsapp-hub/customer`;
export const SALE_ORDER_INVOICE_SMS_URL = `${API_BASE_URL}/core/notifications/sale-order/invoice-sms`;

// Accounting
export const ACCOUNTS_URL = `${API_BASE_URL}/accounting`;
export const ACCOUNTS_TYPES_URL = `${API_BASE_URL}/accounting/type`;
export const ACCOUNTING_BILL_BULK_INVOICE_PAY = `${API_BASE_URL}/accounting/bills/bulk_inv_pay`;
export const ACCOUNTING_VENDORS_URL = `${API_BASE_URL}/accounting/vendors`;
export const ACCOUNTING_PLAID_SYSTEM_PAYMENTS = `${API_BASE_URL}/accounting/plaid/system/payments`;
export const ACCOUNTING_PLAID_SYSTEM_SPENT_RECORDS = `${API_BASE_URL}/accounting/plaid/system/spent-records`;
export const ACCOUNTING_PLAID_SYSTEM_DEPOSITS = `${API_BASE_URL}/accounting/plaid/system/deposits`;
export const ACCOUNTING_PLAID_MATCH_PAYMENTS = `${API_BASE_URL}/accounting/plaid/match`;

//Core
export const SO_MAIL_INVOICE = `${API_BASE_URL}/core/utils/email/so_invoice`;
export const GET_ALL_CUSTOM_PAGES_URL = `${API_BASE_URL}/core/custom_pages/list`;
export const PR_MAIL_INVOICE = `${API_BASE_URL}/core/utils/email/pr_invoice`;
export const USER_URL = `${API_BASE_URL}/core/user`;
export const LOGOUT_USER_URL = `${API_BASE_URL}/core/user/logout-all-devices`;

// Reminders & Notifications
export const NOTIFICATION_URL = `${API_BASE_URL}/core/notifications`;
export const READ_ALL_NOTIFICATIONS_URL = `${API_BASE_URL}/core/notifications/all`;
export const GET_ALL_REMINDERS_URL = `${API_BASE_URL}/core/reminders/list`;
export const REMINDER_URL = `${API_BASE_URL}/core/reminders`;

export const REFRESH_TOKEN = `${API_BASE_URL}/api/dev/core/user/authenticate/refresh`;
export const PRESIGNED_URL = `${API_BASE_URL}/core/utils/presigned_urls`;
export const GET_STATE_URL = `${API_BASE_URL}/core/utils/state`;
export const GET_COUNTY_URL = `${API_BASE_URL}/core/utils/county`;
export const GET_CITY_URL = `${API_BASE_URL}/core/utils/city`;
export const APP_THEME_URL = `${API_BASE_URL}/core/template`;
export const CONSENT_TENANT = `${API_BASE_URL}/core/consent/tenant`;
export const CONSENT_CUSTOMER = `${API_BASE_URL}/core/consent/customer`;
export const CONSENT_SUPPLIER = `${API_BASE_URL}/core/consent/supplier`;
export const CUSTOM_CITIES_URL = `${API_BASE_URL}/core/utils/custom/city/list`;
export const CUSTOM_COUNTIES_URL = `${API_BASE_URL}/core/utils/custom/county/list`;
export const CUSTOM_CITY_URL = `${API_BASE_URL}/core/utils/custom/city`;
export const CUSTOM_COUNTY_URL = `${API_BASE_URL}/core/utils/custom/county`;
//Core => Auth

export const LOGIN_URL = `${API_BASE_URL}/core/user/authenticate`;
export const ME_URL = `${API_BASE_URL}/core/user/me`;
export const REFRESH_TOKEN_URL = `${API_BASE_URL}/core/user/authenticate/refresh`;
export const RESET_PASSWORD_URL = `${API_BASE_URL}/core/user/reset_password`;
export const VERIFY_OTP = `${API_BASE_URL}/core/customers/verify_otp`;
export const PERMISSION_GROUP = `${API_BASE_URL}/core/user/permission/group`;
export const PERMISSION = `${API_BASE_URL}/core/user/permission`;
export const ROLE = `${API_BASE_URL}/core/user/role`;
export const TAX = `${API_BASE_URL}/core/tax`;
//Report
export const MSA_REPORT_URL = `${API_BASE_URL}/report/msa`;
export const BASIC_DASHBOARD_STATS = `${API_BASE_URL}/report/dashboard/basic_stats`;
export const AI_DASHBOARD = `${API_BASE_URL}/report/dashboard/ai-dashboard`;
export const DATA_DASHBOARD_STATS = `${API_BASE_URL}/report/dashboard/stats`;
export const DATA_DASHBOARD_STOCK_ALERT = `${API_BASE_URL}/report/dashboard/stocks`;
export const STOCK_REORDER = `${API_BASE_URL}/report/dashboard/stocks`;
export const STOCK_REORDER_DETAILS = `${API_BASE_URL}/report/inv/purchase-order/history`;
export const DASHBOARD_AGING_INVOICES = `${API_BASE_URL}/report/dashboard/aging_invoices`;
export const CHANNELS_STOCK_REPORT = `${API_BASE_URL}/inventory/stocks/export`;
export const STOCK_ACTIVITY_LOGS = `${API_BASE_URL}/inventory/stocks/activity-log`;
export const STOCK_ACTIVITY_EXPORT = `${API_BASE_URL}/report/inv/stock/activity_log/export`;
export const PRODUCT_REPORT = `${API_BASE_URL}/catalog/products/v3/export`;
export const INVENTORY_REPORT_URL = `${API_BASE_URL}/report/inv/stock/product`;
export const INVENTORY_EVL_REPORT_URL = `${API_BASE_URL}/report/inv/stock`;
export const VENDORS_URL = `${API_BASE_URL}/report/inv/supplier`;
export const RAP_REPORT_URL = `${API_BASE_URL}/report/sale/customer/rap_report`;
export const LDR_REPORT_URL = `${API_BASE_URL}/report/sale/customer/ldr_report`;
export const RCR_REPORT_URL = `${API_BASE_URL}/report/sale/customer/rcr_report`;
export const KCT_REPORT_URL = `${API_BASE_URL}/report/sale/finance/kentucky_cigarette_tax_report`;
export const INDIANA_CIG_REPORT_URL = `${API_BASE_URL}/report/sale/finance/indiana_cigarette_tax_report`;
export const GEORGIA_TAX_REPORT_URL = `${API_BASE_URL}/report/sale/finance/georgia_tax_report`;
export const TENNESSEE_TAX_REPORT_URL = `${API_BASE_URL}/report/sale/finance/tennessee_tax_report`;

export const CATEGORY_PRICE_URL = `${API_BASE_URL}/report/sale/order`;
export const SALE_REPORT_URL = `${API_BASE_URL}/report/sale/order`;
export const SALE_FINANCE_URL = `${API_BASE_URL}/report/sale/finance`;
export const VELOCITY_REPORT_URL = `${API_BASE_URL}/report/sale/order/velocity/price-cost`;
export const PO_BY_VENDOR_REPORT_URL = `${API_BASE_URL}/report/inv/purchase-order/purchase_order_report`;

export const INVOICE_HISTORY_REPORT_URL = `${API_BASE_URL}/report/sale/order/invoice_history`;
export const CUSTOMER_LEDGER_PDF_URL = `${API_BASE_URL}/report/ledger`;
export const PURCHASE_RETURN_HISTORY_URL = `${API_BASE_URL}/report/inv/purchase-order/purchase_return_history/export`;
export const CUSTOMER_CSV_URL = `${API_BASE_URL}/report/ledger`;
export const COUNTY_VELOCITY_REPORT_URL = `${API_BASE_URL}/report/msa`;
export const PURCHASE_RECIEVED_HISTORY_REPORT_URL = `${API_BASE_URL}/report/inv/purchase-order/purchase_receive_history`;
export const PO_REPORT_URL = `${API_BASE_URL}/report/inv/purchase-order`;
export const PickingList_URL = `${API_BASE_URL}/sale/order`;
export const GENERATE_EDI_URL = `${API_BASE_URL}/sale/order`;
export const CUSTOMER_VELOCITY_REPORT_YEAR_ON_YEAR_LIST_URL = `${API_BASE_URL}/report/sale/order/yoy_customer_velocity_report`;
export const CUSTOMER_VELOCITY_REPORT_YEAR_ON_YEAR_URL = `${API_BASE_URL}/report/sale/order/yoy_customer_velocity_report/export`;
export const ITEM_VELOCITY_REPORT_WEEK_ON_WEEK_URL = `${API_BASE_URL}/report/sale/order/week_on_week_item_velocity`;
export const ITEM_VELOCITY_REPORT_MONTH_ON_MONTH_URL = `${API_BASE_URL}/report/sale/order/monthly_item_velocity`;
export const CALIFORNIA_CIGERETTE_SALES_REPORT_URL = `${API_BASE_URL}/report/sale/order/california_cigarette_sales_report/export`;
export const CALIFORNIA_CIGERETTE_SALES_REPORT_DATA_URL = `${API_BASE_URL}/report/sale/order/california_cigarette_sales_report`;
export const PRODUCT_LOGS_EXPORT_URL = `${API_BASE_URL}/core/utils/product_audit_log/export`;
export const POST_DATED_PAYMENTS_REPORTS_URL = `${API_BASE_URL}/report/sale/finance/post_dated_payments`;
export const DRIVER_COLLECTION_REPORTS_URL = `${API_BASE_URL}/report/sale/collection/driver_collection_report`;
export const PRE_DATED_PAYMENTS_REPORTS_URL = `${API_BASE_URL}/report/sale/finance/pre_dated_payments`;

// Delivery & Shipping
export const VEHICLES_URL = `${API_BASE_URL}/delivery/vehicles`;
export const ROUTE_URL = `${API_BASE_URL}/delivery/routes`;

// Basic Settings
export const BASIC_SETTINGS_URL = `${API_BASE_URL}/core/settings_v2/`;
export const S3_BUCKET_URL = "https://khub-app.s3-accelerate.amazonaws.com/";
export const CURRENCY_SETTINGS_URL = `${API_BASE_URL}/core/settings_v2/`;

// Background task status
export const BACKGROUND_TASK_STATUS = `${API_BASE_URL}/core/utils/task`;

// Invoices
export const INVOICE_URL = `${API_BASE_URL}/sale/invoice`;
export const INVOICE_LIST_URL = `${API_BASE_URL}/sale/invoice/list`;

// customer query
export const QUERY_URL = `${API_BASE_URL}/core/customer_query/list`;
export const SINGLE_QUERY_URL = `${API_BASE_URL}/core/customer_query`;
export const DELETE_QUERY_URL = `${API_BASE_URL}/core/customer_query`;

//App Settings
export const INTEGRATION_URL = `${API_BASE_URL}/integrations`;

export const REQUEST_TIMEOUT = 300 * 1000;
export const SESSION_EXPIRED_STATUS_CODE = 401;
export const DEFAULT_PAGE_SIZE = 10;
export const DEFAULT_CURRENT_PAGE = 1;
export const TOAST_MESSAGE_OPTIONS = {
  autoClose: 3000,
  hideProgressBar: false,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
  progress: undefined,
};
export const QUERY_CONFIG = {
  enabled: true, // Set to false to stop continuous loading
  refetchOnWindowFocus: false,
  retry: 3,
  staleTime: 1 * 1000,
};
//payments
export const GP_BUSSINESS_URL = `${API_BASE_URL}/payment/business`;
export const GP_BANK_BALANCE = `${API_BASE_URL}/payment/bank/balance`;
export const GP_PERSON_URL = `${API_BASE_URL}/payment/person`;
export const GP_SUPPLIER_URL = `${API_BASE_URL}/payment/supplier`;
export const GP_BUSSINESS_ONBOARD_URL = `${API_BASE_URL}/payment/business/onboard`;
export const GP_PERSON_ONBOARD_URL = `${API_BASE_URL}/payment/person/onboard`;
export const GP_SUPPLIER_ONBOARD_URL = `${API_BASE_URL}/payment/supplier/onboard`;
export const GP_GET_BANK_DETAIL_CUST = `${API_BASE_URL}/payment/person/bank`;
export const GP_GET_BANK_DETAIL_SUPL = `${API_BASE_URL}/payment/supplier/bank`;
export const GP_GET_BANK_DETAIL_BUSI = `${API_BASE_URL}/payment/business/bank`;
export const NMI_AUTH_URL = `${API_BASE_URL}/payment/gateway/setup`;
export const PUBLIC_PAYMENT_URL = `${API_BASE_URL}/sale/payment/public`;
export const REGISTERED_DEVICES_URL = `${API_BASE_URL}/payment/nmi/device`;
export const NMI_KEYS_URL = `${API_BASE_URL}/payment/nmi/keys`;
export const PAYMENT_ADJUSTMENT_TYPE_URL = `${API_BASE_URL}/sale/balance/adjustment/type`;
export const GET_ALL_PAYMENT_ACCOUNTS = `${API_BASE_URL}/accounting/accounts/list`;

//whatsApp iframes
export const GET_IFRAMES_FOR_WHATSAPP_URL = `${API_BASE_URL}/integrations/whatsapp-hub/iframes`;

export const AI_QUANTITY_SUGGESTIONS_URL = `${API_BASE_URL}/inventory/purchase/v2/orders/ai_suggested_qty_batch`;

export const AI_QUANTITY_SUGGESTIONS_PO_URL = `${API_BASE_URL}/inventory/purchase/v2/orders/ai_powered_po`;

export const BOX_MGMT_URL = `${API_BASE_URL}/sale/box/management`;

export const SHIPPING_API_URL = `${API_BASE_URL}/shipping`;

// SMS Logs Urls
export const SMS_LOGS_URL = `${API_BASE_URL}/core/notifications/sms/logs`;
